import { Option } from '@sortlist-frontend/design-system/legacy';
import { ReactNode } from 'react';
import { components, ControlProps, OptionProps } from 'react-select';

export const IconControl = ({ children, ...props }: ControlProps<unknown, boolean> & { icon: ReactNode }) => {
  const { icon } = props;

  return (
    <components.Control {...props}>
      {icon}
      {children}
    </components.Control>
  );
};

export const IconOption = (props: OptionProps<Option, boolean> & { optionIcon: ReactNode }) => {
  const { optionIcon, data } = props;

  return (
    <components.Option {...props} className="layout-row layout-align-start-center">
      {optionIcon}
      <span>{data.label}</span>
    </components.Option>
  );
};
